<template>
  <div class="relative min-h-96">
    <picture>
      <source v-if="content.cover" :srcset="content.cover.url" media="(min-width: 768px)" />
      <img
        v-if="content.cover_mobile || content.cover"
        :src="content.cover_mobile?.url ?? content.cover?.url"
        class="absolute z-[-1] size-full object-cover"
        :alt="content.cover_mobile?.alt_text ?? content.cover?.alt_text ?? undefined"
      />
    </picture>
    <UiNarrowContainer class="mx-auto min-h-96 items-center md:flex md:flex-row-reverse md:justify-center">
      <div class="flex flex-col px-6 pt-12 md:basis-2/4 md:items-center md:justify-center md:overflow-hidden md:pt-0">
        <img
          v-if="content.main_picture"
          :src="content.main_picture.url"
          :alt="content.main_picture.alt_text ?? undefined"
          class="size-full object-cover md:size-72 md:object-left"
        />
      </div>
      <div class="p-4 md:flex md:max-w-screen-md md:basis-2/4 md:flex-col md:items-start md:justify-center md:p-10">
        <UiHeading type="h1" class="mb-4 mt-2">
          {{ content.title }}
        </UiHeading>
        <UiText type="p">
          {{ content.subtitle }}
        </UiText>
        <div v-if="content.cta" class="mt-6 flex flex-col gap-4 md:flex-row">
          <UiButton
            id="page-hero-cta"
            size="lg"
            :variant="content.cta.type"
            @click="goTo(content.cta.url, { external: true })"
          >
            {{ content.cta.title }}
          </UiButton>
        </div>
      </div>
    </UiNarrowContainer>
  </div>
</template>

<script setup lang="ts">
import type { PageHeroProps } from '~/components/Page/types';

const goTo = useGoTo();

defineProps<PageHeroProps>();
</script>
